"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.wasNotInitializedWithAppointmentData = exports.shouldSkipProvider = exports.isCancelationExpired = exports.isCancelationDisabled = exports.isAppointmentCanceled = exports.hasAppointment = void 0;
const hasAppointment = exports.hasAppointment = '@guard/HAS_APPOINTMENT';
const isAppointmentCanceled = exports.isAppointmentCanceled = '@guard/IS_APPOINTMENT_CANCELED';
const isCancelationDisabled = exports.isCancelationDisabled = '@guard/IS_CANCELATION_DISABLED';
const isCancelationExpired = exports.isCancelationExpired = '@guard/IS_CANCELATION_EXPIRED';
const shouldSkipProvider = exports.shouldSkipProvider = '@guard/SHOULD_SKIP_PROVIDER';
const wasNotInitializedWithAppointmentData = exports.wasNotInitializedWithAppointmentData = '@guard/WAS_NOT_INITIALIZED_WITH_APPOINTMENT_DATA';